import { useContext } from 'react';
import { HubContext } from './HubContext';
import { HubContextType } from './HubTypes';

/**
 * Custom hook to use the Hub context
 * @returns {HubContextType} Hub state and methods
 * @throws {Error} If used outside of HubProvider
 */
export const useHub = (): HubContextType => {
  const context = useContext(HubContext);
  
  if (context === undefined) {
    throw new Error('useHub must be used within a HubProvider');
  }
  
  return context;
}; 